import React, { useContext, useState, useEffect } from "react";
import Layout from "./Layout";
import { DashboardUserContext } from "./Layout";
import { updatePersonalInformationAction } from "./Action";
import { FaWhatsapp } from "react-icons/fa";

const ProfileComponent = () => {
  const { data, dispatch } = useContext(DashboardUserContext);

  const [fData, setFdata] = useState({
    id: "",
    name: "",
    phone: "",
    success: null,
  });

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";

    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    let formattedNumber = cleaned.startsWith("55") ? cleaned.slice(2) : cleaned;

    let match = formattedNumber.match(/^(\d{2})(\d{5})(\d{4})$/);
    if (match) return `+55 (${match[1]}) ${match[2]}-${match[3]}`;

    match = formattedNumber.match(/^(\d{2})(\d{4})(\d{4})$/);
    if (match) return `+55 (${match[1]}) ${match[2]}-${match[3]}`;

    return phoneNumber;
  };

  useEffect(() => {
    if (data?.userDetails?._id) {
      const { _id, name, phone } = data.userDetails;
      setFdata({
        id: _id,
        name,
        phone: formatPhoneNumber(phone),
        success: null,
      });
    }
  }, [data.userDetails]);

  const handleSubmit = () => {
    updatePersonalInformationAction(dispatch, fData);
    setFdata((prevFdata) => ({
      ...prevFdata,
      success: "Dados atualizados com sucesso!",
    }));
  };

  if (data.loading) {
    return (
      <div className="w-full md:w-9/12 flex items-center justify-center py-24">
        <svg
          className="w-12 h-12 animate-spin text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          ></path>
        </svg>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full my-4 md:my-0 md:w-9/12 md:px-8">
      <div className="shadow-lg border">
        <div className="py-4 px-4 text-lg font-semibold border-t-2 border-yellow-700">
          Meu Perfil
        </div>
        <hr />
        <div className="py-4 px-4 md:px-8 lg:px-16 flex flex-col space-y-4">
          {fData.success && (
            <div className="bg-green-200 px-4 py-2 rounded text-green-800">
              {fData.success}
            </div>
          )}
          <div className="flex flex-col space-y-2">
            <label htmlFor="name">Nome completo</label>
            <input
              onChange={(e) => setFdata({ ...fData, name: e.target.value })}
              value={fData.name}
              type="text"
              id="name"
              className="border px-4 py-2 w-full focus:outline-none"
              placeholder="Seu nome completo"
            />
          </div>
          <div className="flex flex-col space-y-2">
            <label htmlFor="phone">Telefone</label>
            <input
              value={fData.phone}
              readOnly
              type="tel"
              id="phone"
              className="cursor-not-allowed border px-4 py-2 bg-gray-200 w-full"
              placeholder="(00) 00000-0000"
            />
            <span className="text-xs text-gray-500">
              O telefone é vinculado à sua conta e não pode ser editado.
            </span>
          </div>
          <button
            onClick={handleSubmit}
            className="w-full text-center bg-black text-white px-4 py-2 rounded hover:bg-gray-900 transition-colors duration-200"
          >
            Salvar Alterações
          </button>
          <div className="mt-4 text-center">
            <span className="text-gray-600">
              Precisa de ajuda? Fale com o time da Flitz:
            </span>
            <br />
            <a
              href="mailto:contato@flitz.com"
              className="text-blue-500 underline"
            >
              contato@flitz.com
            </a>
            <div className="mt-4">
              <a
                href="https://wa.me/559591273913?text=Olá,%20estou%20na%20sessão%20de%20perfil%20da%20Flitz%20e%20preciso%20de%20ajuda."
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-3 py-2 bg-green-500 text-white rounded-full shadow-md hover:bg-green-600 transition-colors duration-200"
                aria-label="Contato via WhatsApp"
              >
                <FaWhatsapp className="mr-2" />
                Falar com a Flitz
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const UserProfile = () => (
  <Layout>
    <ProfileComponent />
  </Layout>
);

export default UserProfile;